import { render, staticRenderFns } from "./ErrorMangement.vue?vue&type=template&id=07bb54a9"
import script from "./ErrorMangement.vue?vue&type=script&lang=js"
export * from "./ErrorMangement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports